import { useSearchParams } from 'react-router-dom';
import { adminApi } from '../../services/api';
import BrandLogo from '../../components/BrandLogo';

const errorMessages: Record<string, string> = {
  not_staff: 'Kontot tillhör inte Flank Speed. Logga in med ditt @flankspeed.se-konto.',
  signin_failed: 'Inloggningen misslyckades. Försök igen.',
  signin_expired: 'Inloggningen tog för lång tid. Försök igen.',
  signin_unavailable: 'Microsoft-inloggning är inte konfigurerad på servern.'
};

export default function AdminLogin() {
  const [searchParams] = useSearchParams();
  const errorCode = searchParams.get('error');
  const error = errorCode ? errorMessages[errorCode] || 'Inloggningen misslyckades.' : '';

  const signIn = () => {
    window.location.href = adminApi.signInUrl(searchParams.get('returnTo') || '/admin/dashboard');
  };

  return (
    <main className="bg-grad-hero relative flex min-h-[100dvh] flex-col px-4 py-6 sm:px-8 sm:py-8">
      <BrandLogo tone="light" product="Settled Admin" />

      <div className="flex flex-1 items-center justify-center py-12">
        <div className="panel w-full max-w-[26rem] p-8 sm:p-10">
          <p className="inline-flex items-center gap-3 text-[12px] font-medium uppercase tracking-[0.2em] text-brass">
            <span aria-hidden className="bg-grad-line h-[2px] w-8" />
            Administration
          </p>
          <h1 className="font-display mt-4 text-2xl leading-tight text-ink">Logga in</h1>
          <p className="mt-3 text-[15px] leading-relaxed text-muted">
            Hantera tenants, Business Central-kopplingar och leverantörsinloggningar.
          </p>

          {error && (
            <p role="alert" className="mt-6 border-l-2 border-red-500 bg-red-50 px-4 py-3 text-sm text-red-800">
              {error}
            </p>
          )}

          <button
            type="button"
            onClick={signIn}
            className="group mt-8 flex w-full items-center justify-center gap-3 rounded-full bg-navy px-6 py-3.5 text-[15px] font-medium text-white shadow-[0_14px_30px_-14px_rgb(0_22_49_/_0.9)] transition-all duration-500 ease-fluid hover:bg-[#0b223d] active:scale-[0.98]"
          >
            <svg className="h-5 w-5" viewBox="0 0 21 21" aria-hidden="true">
              <rect x="1" y="1" width="9" height="9" fill="#f25022" />
              <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
              <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
              <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
            </svg>
            Logga in med Microsoft
          </button>

          <p className="mt-5 text-center text-sm text-muted">Endast för Flank Speed-personal.</p>
        </div>
      </div>

      <p className="text-center text-sm text-white/60">Settled Portal · Flank Speed Consulting</p>
    </main>
  );
}
